import React, { useEffect, useState } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { generatePath, Link, useNavigate } from 'react-router-dom';
import { ClusterOutlined, EyeOutlined, GlobalOutlined, UserOutlined } from '@ant-design/icons';
// import styles from './index.module.scss';
import ListPage from '@components/common/layout/ListPage';
import PageWrapper from '@components/common/layout/PageWrapper';
import ImageCol from '@components/common/table/ImageCol';
import {
    AppConstants,
    categoryKind,
    DEFAULT_FORMAT,
    DEFAULT_TABLE_ITEM_SIZE,
    DEFAULT_TABLE_ITEM_SIZE_LARGE,
} from '@constants';
import apiConfig from '@constants/apiConfig';
import { FieldTypes } from '@constants/formConfig';
import { statusOptions } from '@constants/masterData';
import useFetch from '@hooks/useFetch';
import useListBase from '@hooks/useListBase';
import useNotification from '@hooks/useNotification';
import useTranslate from '@hooks/useTranslate';
import { AvatarField, BaseTable,BaseTooltip } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { convertUtcToLocalTime } from '@utils';
import { Button, Divider, Modal, Tag } from 'antd';

import routes from './routes';
const message = defineMessages({
    objectName: 'Media Library',
});

const InwenListPage = () => {
    const translate = useTranslate();
    const navigate = useNavigate();
    const notification = useNotification();
    const statusValues = translate.formatKeys(statusOptions, [ 'label' ]);
    const [ showPreviewModal, setShowPreviewModal ] = useState(false);

    const { data, mixinFuncs, queryFilter, loading, pagination } = useListBase({
        apiConfig: apiConfig.inwen,
        options: {
            pageSize: DEFAULT_TABLE_ITEM_SIZE_LARGE,
            objectName: translate.formatMessage(message.objectName),
        },
        override: (funcs) => {
            funcs.mappingData = (response) => {
                if (response.result === true) {
                    return {
                        data: response.data.content,
                        total: response.data.totalElements,
                    };
                }
            };
            funcs.additionalActionColumnButtons = () => {
                return {
                    navigateToChildPage: (record) => {
                        if (!record.hasChild) {
                            return (
                                <BaseTooltip title={'Go to Child Page'}>
                                    <Link
                                        to={`${generatePath(routes.inwenChildListPage.path, { id: record.id })}?parentId=${record.id}&name=${record.inwenMediaLibraryName}`}
                                    >
                                        <Button type="link" style={{ padding: 0 }}>
                                            <ClusterOutlined />
                                        </Button>
                                    </Link>
                                </BaseTooltip>
                            );
                        }
                        return null;
                    },
                };
            };
        },
    });

    const columns = [
        {
            title: <FormattedMessage defaultMessage="Image" />,
            dataIndex: 'inwenMediaLibraryData',
            render: (value) => (
                <ImageCol
                    style={{ backgroundColor: '#232935', objectFit: 'contain' }}
                    path={value ? `data:image/jpeg;base64,${value}` : null}
                    className="img-inwen"
                />
            ),
            width: '150px',
        },
        {
            title: <FormattedMessage defaultMessage="Name" />,
            dataIndex: 'inwenMediaLibraryName',
            render: (name, datarow) => {
                return (
                    <>
                        {datarow.hasChild ? (
                            <Link
                                to={`${generatePath(routes.inwenChildListPage.path, { id: datarow.id })}?parentId=${datarow.id}&name=${datarow.inwenMediaLibraryName}`}
                            >
                                {name}
                            </Link>
                        ) : (
                            <span>{name}</span>
                        )}
                    </>
                );
            },
        },
        mixinFuncs.renderActionColumn(
            {
                navigateToChildPage: true,
                edit: true,
                delete: true,
            },
            { width: '130px' },
        ),
    ];

    const searchFields = [
        {
            key: 'inwenMediaLibraryName',
            placeholder: translate.formatMessage(commonMessage.Name),
        },
    ];

    return (
        <PageWrapper routes={[ { breadcrumbName: translate.formatMessage(commonMessage.MediaLibrary) } ]}>
            <ListPage
                searchForm={mixinFuncs.renderSearchForm({ fields: searchFields, initialValues: queryFilter })}
                actionBar={mixinFuncs.renderActionBar()}
                baseTable={
                    <BaseTable
                        onChange={mixinFuncs.changePagination}
                        columns={columns}
                        dataSource={data}
                        // loading={loading || getCategoriesLoading || updateNewsPinLoading}
                        pagination={pagination}
                    />
                }
            />
            <Modal
                title={<FormattedMessage defaultMessage="Preview" />}
                width={1000}
                open={showPreviewModal}
                footer={null}
                centered
                onCancel={() => setShowPreviewModal(false)}
            >
                {/* {newsContent && (
                    <div className={styles.previewContent} dangerouslySetInnerHTML={{ __html: newsContent }}></div>
                )} */}
            </Modal>
        </PageWrapper>
    );
};

export default InwenListPage;
